module.exports = __webpack_public_path__ + "img/icon_map_2_5_yj_c.86451ac6.png";